









import { defineComponent, PropType } from "@vue/composition-api";
import useNSFWUserSettings from "@/hooks/useNSFWUserSettings";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseSwitch from "@/components/BaseSwitch";
import { IMoreMenuItem } from "@/views/PageMore/config";

export default defineComponent({
  name: "MoreMenuItemNSFWUserSetting",
  components: { BaseSwitch, BaseIcon },
  props: {
    item: { type: Object as PropType<IMoreMenuItem>, required: true },
  },
  setup() {
    const { showNotSafeForWork, toggleNSFWUserSettings } = useNSFWUserSettings();

    return {
      showNotSafeForWork,
      toggleNSFWUserSettings,
    };
  },
});
